export default __webpack_public_path__ + "static/media/help_icon.57732b04.jpg";